import React from 'react';
import Layout from '../../Shared/Layout';

import { Chat as ChatComponent } from "../../Shared/Chat";
import Wrapper from "./Wrapper";

export default function Chat({ client, order, statuses, services, partners,
    coverages, settlements, materialOperations,
    files, userCanUpdate, orderattributes,
    orderhistories, extendedMode, permissions, returnUrl,
}) {
    return (
        <Wrapper>
            <ChatComponent />
        </Wrapper>
    )
}

Chat.layout = page => <Layout children={page} />;
